/**
 * #280 -- the badge map for ledger entry types. `clawback` is a member of
 * `CommissionEntryType`, so this map is a compile error until it covers every
 * type the API can return.
 */
import type { CommissionEntryType } from '../../types';

export type LedgerBadgeVariant = 'success' | 'error' | 'warning' | 'default' | 'info';

/**
 * `clawback` is `error`, not `warning`: a reversal unwinds an accrual nobody
 * received, while a clawback is a debt for money that already left. Colouring
 * them the same would hide the distinction the entry type exists to make.
 */
export const entryTypeBadgeVariant: Record<CommissionEntryType, LedgerBadgeVariant> = {
  earned: 'success',
  payout: 'error',
  reversal: 'warning',
  clawback: 'error',
  tds: 'default',
  gst: 'default',
  adjustment: 'info',
};
